<template>
    <vx-selectable v-model="model"
        placeholder="Search"
        :reduce="props.reduce"
        :loading="loading"
        :options="options"
        :clearable="props.clearable"
        label="name"
        value="id"
        @search="search"
        data-test="org-unit-selectable">
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { computed, onUnmounted } from 'vue';
import { orgUnitsClient } from '~/services';
import { useSearchRequest } from '~/composables/useSearchRequest';
import { NO_ORG_UNIT, NO_ORG_UNIT_LABEL } from '~/constants/orgUnit';

const props = defineProps({
    clearable: {
        type: Boolean,
        default: true,
    },
    noOrgUnitOption: {
        type: Boolean,
        default: false,
    },
    reduce: {
        type: Function,
        default: undefined,
    },
    teamId: {
        type: Number,
        default: undefined,
    },
});

const teamId = props.teamId ?? Spark.state.currentTeam.id;
const model = defineModel();

const {
    loading,
    response,
    createSearch,
    cancelSearch,
    cancelKey,
} = useSearchRequest(orgUnitsClient);

const options = computed(() => (props.noOrgUnitOption
    ? [{ id: NO_ORG_UNIT, name: NO_ORG_UNIT_LABEL }, ...(response.value ?? [])]
    : response.value));

const search = createSearch(async (query) => {
    const { data } = await orgUnitsClient.listOrgUnits(teamId, {
        query: query,
    }, {
        cancelKey: cancelKey,
    });

    return data.data.map((orgUnit) => ({
        id: orgUnit.id,
        name: orgUnit.name
    }));
});

// Initialize with empty search
search();

// Clean up on component unmount
onUnmounted(() => {
    cancelSearch();
});
</script>
